<div class="designer">
    <nlr-ribbon></nlr-ribbon>
    <svg
        width="0"
        height="0"
        viewBox="0 0 0 0"
        style="position:absolute;width:0;height:0;">
        <defs [innerHTML]="getLineSvgDefs()"></defs>
        <style>
            @font-face {
                font-family: 'NLRP Icons';
                src: url('fonts/nlrp-fonts.otf');
            }
            @keyframes feature-symbol-hover {to {opacity:0.01;}}
        </style>
        <style [innerHTML]="getLineSvgStyle()"></style>
        <style [innerHTML]="getStaticPointSvgStyle()"></style>
        <style [innerHTML]="getPointSvgStyle()"></style>
        <style [innerHTML]="getControlPointSvgStyle()"></style>
        <style [innerHTML]="getConstructPointSvgStyle()"></style>
        <style [innerHTML]="getAngleSvgStyle()"></style>
        <style [innerHTML]="getAnnotationSvgStyle()"></style>
        <style [innerHTML]="getConstructLineSvgStyle()"></style>
        <style [innerHTML]="getPolylineSvgStyle()"></style>
        <style [innerHTML]="getPolygonSvgStyle()"></style>
        <style [innerHTML]="getLotSvgStyle()"></style>
        <style [innerHTML]="getRoadSvgStyle()"></style>
        <style [innerHTML]="getInterestSvgStyle()"></style>
        <style [innerHTML]="getEnlargementSvgStyle()"></style>
        <style [innerHTML]="getClippingSvgStyle()"></style>
        <style [innerHTML]="getPrintAreaSvgStyle()"></style>
    </svg>
    <div
        id="{{getDesignProperties().DESIGN_SETTINGS.DEFAULT_MAP.ID}}"
        class="map"></div>
</div>
